<template>
  <div class="observatory-usage-guide">
    <div
      v-for="(usageItem, index) in usageGuide"
      :key="index"
      class="legend-area"
    >
      <div class="legend-title" v-if="usageItem.title">
        {{ usageItem.title }}
      </div>
      <v-card class="legend" tile elevation="5">
        <div
          v-for="(o, index) in usageItem.colors"
          :key="index"
          class="val"
          :style="{ backgroundColor: o.color }"
        >
          {{ o.value }}
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import { STAGES } from "../../../enums/Type";
export default {
  name: "ObservatoryUsageGuide",
  data() {
    return {
      usageGuide: [
        {
          title: "水位",
          colors: [
            { color: STAGES.OUTBREAK.color, value: STAGES.OUTBREAK.label },
            { color: STAGES.DANGEROUS.color, value: STAGES.DANGEROUS.label },
            { color: STAGES.EVACUATION.color, value: STAGES.EVACUATION.label },
            { color: STAGES.WARNING.color, value: STAGES.WARNING.label },
            { color: STAGES.STANDBY.color, value: STAGES.STANDBY.label },
            { color: STAGES.START.color, value: STAGES.START.label },
            { color: STAGES.NORMAL.color, value: STAGES.NORMAL.label },
            { color: STAGES.DEFICIT.color, value: STAGES.DEFICIT.label }
          ]
        },
        {
          title: "雨量(mm/10分)",
          colors: [
            { color: "#800080", value: "20㎜以上" },
            { color: "#ff0000", value: "10㎜以上" },
            { color: "#d88100", value: "5㎜以上" },
            { color: "#1e42af", value: "1㎜以上" },
            { color: "#ffffff", value: "1㎜未満" },
            { color: "#aaaaaa", value: "休止・欠測等" }
          ]
        }
      ]
    };
  }
};
</script>

<style scoped lang="scss">
.observatory-usage-guide {
  overflow: hidden;
  padding-bottom: 10px;
}
.legend-area {
  float: right;
  margin-left: 5px;
  .legend-title {
    text-align: right;
    font-size: 12px;
    font-weight: bold;
    white-space: pre;
    text-shadow: 1px 1px 0 #ffffff, -1px 1px 0 #ffffff, 1px -1px 0 #ffffff,
      -1px -1px 0 #ffffff;
  }
  .legend {
    float: left;
    .val {
      color: #ffffff;
      text-shadow: 1px 1px 0 #2c2c2c, -1px 1px 0 #2c2c2c, 1px -1px 0 #2c2c2c,
        -1px -1px 0 #2c2c2c;
      font-weight: bold;
      font-size: 12px;
      min-width: 12px;
      text-align: center;
      line-height: 1;
      padding: 0 10px;
      line-height: 20px;
      height: 20px;
      opacity: 0.9;
    }
  }
}
</style>
